import React, { useState } from "react";
// import loginLogo from "./../../../Assets/icons/LoginLogoRightSide.png"
import loginLogo from "./../../../Assets/icons/Newtron  white bg 1.png";
// import EwentLogo from "./../../../Assets/images/Logo 2 (1).png";
import EwentLogo from "./../../../Assets/icons/Newtron logo_w_circle.svg";
import backicon from "./../../../Assets/icons/Group 1707478226.svg";
import OTPInput from "../../customComponents/CustomOTP/OTPInput";
import CustomInput from "../../customComponents/CustomInput/CustomInput";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { showAlert } from "../../customComponents/CustomSweetAlert/ShowAlert";

import "./index.scss";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../../services/api/API";

const ResetPassword = () => {
  const [showModal, setShowModal] = useState(false);
  const [error, setError] = useState(null);
  const [password, setPassword] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");

  const location = useLocation();
  const passwordReset = location.state?.passwordReset;

  const [loading, setLoading] = useState(false);

  const { id } = useParams();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true); // Start loading

    // Basic validation
    if (!currentPassword || !password) {
      setError("Please enter both password.");
      setLoading(false);
      return;
    }

    if (password !== currentPassword) {
      setError("Passwords do not match.");
      setLoading(false);
      return;
    }

    // Strong password validation
    const strongPasswordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    if (!strongPasswordRegex.test(currentPassword)) {
      setError(
        "Password must be at least 8 characters long, contain at least one uppercase letter, one lowercase letter, one number, and one special character."
      );
      setLoading(false);
      return;
    }

    try {
      const payload = {
        password: password,
        confirmPassword: currentPassword,
      };

      let response;

      if (passwordReset === 0) {
        // Call /change-password if passwordReset is 0
        response = await axiosInstance.patch(`/change-password/${id}`, payload);
      } else {
        // Default reset-password flow
        response = await axiosInstance.patch(`/reset-password/${id}`, payload);
      }

      if (response.status === 200) {
        await showAlert({
          title: "Success",
          text: "Password Changed Successfully",
          icon: "success",
          confirmButtonText: "OK",
        });
        navigate("/");
      } else {
        setError(
          "Failed to log in. Please check your credentials and try again."
        );
      }
    } catch (error) {
      console.error("Error logging in:", error);
      setError(
        error?.response?.data?.data?.message ||
          "An error occurred. Please try again later."
      );
    }
  };

  return (

      <div  className="mainContainer-resetPassword">
        <div style={{ position: "relative" }} className="parent-Container ">
          <img src={EwentLogo} alt="ewentLogo" className="image-css" />
          <div className="loginImage ">
            <img
              style={{ height: "21rem", width: "21rem", objectFit: "contain" }}
              src={loginLogo}
              alt="Login"
              className="img-fluid"
            />
          </div>
          <div className="loginContainer ">
            <h3 className="logintitle mb-3">Reset Password</h3>
            <form onSubmit={handleLogin}>
              <div className="loginInputsContainer">
                <CustomInput
                  placeholder="Password"
                  type="password"
                  value={currentPassword}
                  autoComplete="off"
                  onChange={(e) => {
                    setCurrentPassword(e.target.value);
                    if (error) setError(null);
                  }}
                  required
                />
                <CustomInput
                  placeholder="Confirm Password"
                  type="password"
                  value={password}
                  autoComplete="off"
                  onChange={(e) => {
                    setPassword(e.target.value);
                    if (error) setError(null);
                  }}
                  required
                />
                {error && <p className="error">{error}</p>}
              </div>
              <div className="mt-3">
                <button type="submit" className="loginButton">
                  {/* {loading ? "Submitting..." : "Submit"} Change button text based on loading state */}
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

  );
};

export default ResetPassword;
